import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { Container, Content, SplitMessage } from './styles';
import Layout from '../../containers/Layout';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import Warning from '../../components/Warning';
import Button from '../../components/Button';
import { useDefaultGtm } from '../../hooks/gtm/default/useDefaultGtm';

const ErrorOnPayment: React.FC = () => {
  const { goBack, replace } = useHistory();
  const { sendDataToGtm } = useDefaultGtm();

  const { state: locationState } = useLocation<any>();
  const { id } = useParams<any>();

  useEffect(() => {
    sendDataToGtm({
      type: 'checkout',
      name: '/pagamento/infos-pagamento-error',
    });
  }, []);

  const handleButtuonTryAgain = () =>
    locationState && locationState.code === 4024 ? replace(`/${id}`) : goBack();

  return (
    <Layout dark>
      <Container>
        <ImageTitle
          data-cy='payment-failed'
          icon={Icons.alertOrder}
          text="Não conseguimos concluir o seu pagamento."
          primary
        />
        <Content>Por favor, verifique os pontos abaixo:</Content>

        <ImageTitle
          icon={Icons.creditCardNumber}
          text="O número do cartão e a validade estão corretos?"
        />

        <SplitMessage />

        <ImageTitle
          icon={Icons.creditCardLimit}
          text="O valor da compra não excedeu o limite do seu cartão?"
        />

        <br />
        <br />

        <Warning>
          Se você preferir utilizar um outro cartão de crédito, favor entrar em
          contato e solicitar ao vendedor.
        </Warning>

        <br />

        <Button data-cy='try-again-button' theme="MINIMAL" onClick={handleButtuonTryAgain}>
          Tentar novamente
        </Button>
      </Container>
    </Layout>
  );
};

export default ErrorOnPayment;
